import React, { useContext } from 'react';
// import { useLocation } from 'react-router-dom';
import { UserContext } from '../../App';

const AdminHome = (props) => {
    const { currentUser } = useContext(UserContext);
    // const { state } = useLocation();
    return (
        currentUser ?
            <div>
                <div className="col-lg-12 col-md-12 col-sm-12 pt-4">
                    <h1><center>Dashboard</center></h1>

                    <div className="text-center pt-1">
                        <h5>
                            MSBTE Web Admin
                        </h5>
                    </div>
                </div>
            </div>
            : null
    );
};

export default AdminHome;